'use client'

import Link from '@/lib/react-compat/link'
import { ChevronRight } from 'lucide-react'
import { useScrollAnimation } from '@/hooks/use-scroll-animation'
import { useI18n } from '@/components/i18n-provider'

const APPLE_EASE = 'ease-[cubic-bezier(0.28,0.11,0.32,1)]'

export function CTASection() {
  const { t } = useI18n()
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation()
  const { elementRef: listRef, isVisible: listVisible } = useScrollAnimation({ threshold: 0.1 })

  const cards = [
    {
      title: t('cta.cards.recommendation.title'),
      desc: t('cta.cards.recommendation.desc'),
      btn: t('cta.cards.recommendation.btn'),
      href: '/recommendation',
    },
    {
      title: t('cta.cards.price.title'),
      desc: t('cta.cards.price.desc'),
      btn: t('cta.cards.price.btn'),
      href: '/price-prediction',
    },
    {
      title: t('cta.cards.disease.title'),
      desc: t('cta.cards.disease.desc'),
      btn: t('cta.cards.disease.btn'),
      href: '/disease-detection',
    },
  ]

  return (
    <section className="bg-black py-24 text-white sm:py-28">
      <div className="container">
        <div
          ref={titleRef}
          className={`mx-auto max-w-2xl text-center transition-all duration-700 ${APPLE_EASE} ${
            titleVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'
          }`}
        >
          <h2 className="text-balance text-3xl font-semibold tracking-[-0.02em] sm:text-5xl">
            {t('cta.title')}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-white/60">{t('cta.subtitle')}</p>
        </div>

        <div
          ref={listRef}
          className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-3"
        >
          {cards.map((card, index) => (
            <Link
              key={index}
              href={card.href}
              className={`group flex flex-col rounded-[28px] bg-white/[0.06] p-8 transition-all duration-500 hover:-translate-y-1 hover:bg-white/[0.1] ${APPLE_EASE} ${
                listVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
              }`}
              style={{ transitionDelay: listVisible ? `${index * 100}ms` : '0ms' }}
            >
              <h3 className="text-xl font-semibold tracking-tight">{card.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-white/55">{card.desc}</p>
              <span className="mt-8 inline-flex items-center gap-0.5 text-sm font-medium text-green-400">
                {card.btn}
                <ChevronRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
